import { render, staticRenderFns } from "./AgendaManager.vue?vue&type=template&id=681e6fb8&scoped=true"
import script from "./AgendaManager.vue?vue&type=script&lang=js"
export * from "./AgendaManager.vue?vue&type=script&lang=js"
import style0 from "./AgendaManager.vue?vue&type=style&index=0&id=681e6fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e6fb8",
  null
  
)

export default component.exports